
const apis = require.context('.', false, /.*\.js$/);

import setting from './setting'
import accountbook from './accountbook'

// 整合所有接口模块
const apiObj = {
	setting,
	accountbook,
}

apis.keys().forEach(fileName => {
	if (fileName !== './index.js') {
		const name = fileName.substring(2, fileName.lastIndexOf('.'))
		apiObj[name] = apis(fileName).default;
	}
});

export default apiObj;
